import DOMPurify from "dompurify"

import { Dispatch, SetStateAction, useEffect, useState} from "react";
import {  parseRestaurantType, TypeResto } from "./restaurantTypes";

export type Menu = MenuContentPage[];
export type Alignment = 'left' | 'center' | 'right' | 'justify';

export interface MenuContentPage {
  elements: MenuElement[]; 
  imgback?: {url:string,iscropp:boolean};
  colorback?:string,
  fontfamilytext?: string;
  fontfamilytitle?: string;
  borderpage?:BorderMenuPage;
}
export const emptyMenuPage:MenuContentPage = {
  elements: [],
}

export type MenuElement = 
  | MenuTitle
  | MenuText
  | MenuSpace
  | MenuImg
  | MenuSeparation;

interface BaseElemProps {
  fontSize?: number;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  alignement?: Alignment;
  fontSizeDesc?: number;
  colorDesc?: string;
  boldDesc?: boolean;
  italicDesc?: boolean;
}
export interface BorderMenuPage {
  color?: string;
  colorline?:string;
  transparent?: boolean;
}

export interface MenuTitle {
  type: 'title';
  props: {
    text: string;
    underline?: boolean;
    style?: number;
  } & BaseElemProps;
}

export interface MenuText {
  type: 'text';
  props: {
    text: string;
    marginLeft?:number,
    marginRight?:number,
    price?: string;
    description?: string;
    visibleDesc?:boolean;
    image?: string; 
  } & BaseElemProps ;
}

export interface MenuSpace {
  type: 'space';
  props: {
    size?: number;
  };
}
export interface MenuSeparation {
  type: 'separation';
  props: {
    height?:number;
    type?:number;
    color?: string;
    alignement?: string;
    width?:number;
    wave?:number;
    degrade?:boolean,
  };
}

export interface MenuImg {
  type: 'img';
  props: {
    url: string;
    width?:number;
    top?:number;
    left?:number;
    border?: number;
    borderColor?:string;
    borderRadius?: number;
    opacity?:number,
  }
}
export type DisplayMenuItem =
  | { type: "menu"; data: contentMenuList; sourceIndex: number }
  | { type: "daily"; data: typeDailyMenu; sourceIndex: null };
export type contentMenuList = {
    menu?:Menu,
    stylemenu?:number,
    interactmenu?:boolean,
    name?:string,
    display_order:number,
    visible?:boolean,
    linkpdf?:string,
    link_img_pdf?:string,
    date_update?:Date,
    period_start?:Date,
    period_end?:Date,
    id?:number,
    isbase?:boolean,
    local_uid?:string
}
export function getImgUrlFromBannerContentItem(item:bannerImgBlock|null) {
  if (!item) return null;
  if (typeof item === 'string') return item;    
  if (typeof item === 'object' && typeof item.link === 'string') return item.link;
  return null;
}
export interface bannerImgBlock {
  type: 'img';
  link:string,
}
export interface SeparationBannerResto {
  c:string, //color
  s:number //size
}
export interface LogoBannerResto {
  link:string,
  props?: {
    heightPct?: number;
    radius?:number,
    border?: number;
    borderColor?:string;
    opacity?:number,
  };
}
export interface FilterBannerResto {
  backColor:string,
  opacity:number,
  title?: PageRestoTitle;
  text?: PageRestoText;
}
export interface BasePropsBannerResto {
  separation?:SeparationBannerResto,
  logo?:LogoBannerResto,
  filter?:FilterBannerResto,
}
export type contentBannerResto =
  | ({  v: 1; id: 1; content: bannerImgBlock[];} & BasePropsBannerResto)
  | ({  v: 1; id: 2; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 3; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 4; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 5; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 6; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 7; content: bannerImgBlock[] } & BasePropsBannerResto);
const emptyBannerImgBlock:bannerImgBlock = {"type":"img","link":""};
export const emptyBannerRestau:contentBannerResto[] = [
    {  v: 1, id: 1, content: [emptyBannerImgBlock]},                     
    {  v: 1, id: 2, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},                       
    {  v: 1, id: 3, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 4, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 5, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 6, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 7, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]}
  ] 

export type TextRun = { t: string; bold?: boolean; italic?: boolean;underLine?: boolean; color?: string; href?: string };

export interface PageRestoTitle {
  fontSize?: number;
  color?: string;
  align?: Alignment;
  runs?:TextRun[];
  lineHeight?:number,
}
  
export interface PageRestoText {
  fontSize?: number;
  color?: string;
  align?: Alignment;
  runs?:TextRun[];
  lineHeight?:number,
}

export interface TextBlock {
  type: 'textblock';
  props: {
    title: PageRestoTitle;
    text: PageRestoText;
  }
}


export interface ImgBlock {
  type: 'img';
  props: {
    link: string;
    radius?: number;
    border?: number;
    borderColor?:string;
    opacity?:number,
    hasInfo?:boolean,
    textInfo?:string
  }
}

export interface SpaceBlock {
  type: 'space';
  props: {
    size?: number;
    height?:number;
    type?:number;
    color?: string;
    alignement?: string;
    width?:number;
    wave?:number;
    degrade?:boolean,
  };
  backColor?:string
}
export interface BaseFontFamiliyBlockProps {
  fonttitle?:string; 
  fonttext?:string;
  alignTop?:boolean,
  margeTop?:number,
  margeBottom?:number,
  backColor?:string
}
export interface VideoBlock {
  type: 'video';
  props: {
    linkFacebook: string;
    linkInsta: string;
    linkCurrent:string;
    chooseFacebook: boolean;
    reverse?:boolean;
    colorlink?:string;
    colorsep?:string;
    degrade?:boolean,
  }
}
export type contentBlockRestau =
  | ({ id: 1; content: [TextBlock] } & BaseFontFamiliyBlockProps)
  | ({ id: 2; content: [ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 3; content: [ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 4; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 5; content: [ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 6; content: [TextBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 7; content: [ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 8; content: [TextBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 9; content: [ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 10; content: [ImgBlock, TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 11; content: [ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 12; content: [ImgBlock, TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 13; content: [ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 14; content: [TextBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 15; content: [ImgBlock, ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 16; content: [TextBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 17; content: [ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 18; content: [ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 19; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 20; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 21; content: [VideoBlock, TextBlock]} & BaseFontFamiliyBlockProps)
  | ({ id: 22; content: [ImgBlock, ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 23; content: [TextBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 24; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 25; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 26; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock,ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 27; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock,ImgBlock,ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 28; content: [ImgBlock,TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 29; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 30; content: [ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 31; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps );
const emptyTextBlock:TextBlock = {"type":"textblock",props:{
  "title":{"runs":[{"t":''}]},"text":{"runs":[{"t":''}]}
}};
const emptyImgBlock:ImgBlock = {"type":"img",props:{"link":""}};
export const emptySpaceBlock:SpaceBlock = {"type":"space",props:{}};
const emptyVideoBlock:VideoBlock =   {"type" : 'video',props: {linkFacebook: '',linkInsta: '',linkCurrent:'',chooseFacebook:false}};

export const emptyBlockRestau:contentBlockRestau[] = [
    { id: 1, content: [emptyTextBlock] },                     
    { id: 2, content: [emptyImgBlock] },                       
    { id: 3, content: [emptyImgBlock] },                         
    { id: 4, content: [emptyTextBlock, emptyImgBlock] },            
    { id: 5, content: [emptyImgBlock, emptyTextBlock] },
    { id: 6, content: [emptyTextBlock, emptyTextBlock] }, 
    { id: 7, content: [emptyImgBlock, emptyImgBlock] },     
    { id: 8, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock] },     
    { id: 9, content: [emptyImgBlock, emptyImgBlock, emptyTextBlock] }, 
    { id: 10, content: [emptyImgBlock,emptyTextBlock, emptyImgBlock] },   
    { id: 11, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 12, content: [emptyImgBlock, emptyTextBlock, emptyImgBlock] }, 
    { id: 13, content: [emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 14, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock] },
    { id: 15, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 16, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 17, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 18, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 19, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 20, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 21, content: [emptyVideoBlock, emptyTextBlock] },
    { id: 22, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 23, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 24, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 25, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 26, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock] },
    { id: 27, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock] },
    { id: 28, content: [ emptyImgBlock, emptyTextBlock] },            
    { id: 29, content: [emptyTextBlock, emptyImgBlock] },
    { id: 30, content: [emptyImgBlock, emptyTextBlock] }, 
    { id: 31, content: [emptyTextBlock, emptyImgBlock] }, 
  ];

export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%*/^\.])[A-Za-z\d!@#$%*/^\.]{8,}$/;
export const plageHours = [
  '00h00', '00h15', '00h30', '00h45',
  '01h00', '01h15', '01h30', '01h45',
  '02h00', '02h15', '02h30', '02h45',
  '03h00', '03h15', '03h30', '03h45',
  '04h00', '04h15', '04h30', '04h45',
  '05h00', '05h15', '05h30', '05h45',
  '06h00', '06h15', '06h30', '06h45',
  '07h00', '07h15', '07h30', '07h45',
  '08h00', '08h15', '08h30', '08h45',
  '09h00', '09h15', '09h30', '09h45',
  '10h00', '10h15', '10h30', '10h45',
  '11h00', '11h15', '11h30', '11h45',
  '12h00', '12h15', '12h30', '12h45',
  '13h00', '13h15', '13h30', '13h45',
  '14h00', '14h15', '14h30', '14h45',
  '15h00', '15h15', '15h30', '15h45',
  '16h00', '16h15', '16h30', '16h45',
  '17h00', '17h15', '17h30', '17h45',
  '18h00', '18h15', '18h30', '18h45',
  '19h00', '19h15', '19h30', '19h45',
  '20h00', '20h15', '20h30', '20h45',
  '21h00', '21h15', '21h30', '21h45',
  '22h00', '22h15', '22h30', '22h45',
  '23h00', '23h15', '23h30', '23h45',
  '00h00'
];
export const baseDays = ["Dimanche","Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", ];

export const baseGenre =['M.','Mme','Autre']


export type typeSpecialDate = { [key: string]: [boolean,[string, string][]] }
export type typeSchedule = { [key: string]: [[string, string],[string,string]] | string }
const toMinutes = (value: string) => {
    const [h, m] = value.split("h").map(Number);
    return h * 60 + m;
};
export const isBetween = (start:string,end:string,hour:string) => {
    const rawStart = toMinutes(start);
    let startMin = rawStart - 15;
    let endMin = toMinutes(end);
    let hourMin = toMinutes(hour)
  
    if (startMin < 0) {
        startMin += 24 * 60;
    }
    if (endMin <= rawStart) {
        endMin += 24 * 60;
        if (hourMin < startMin) {
            hourMin += 24 * 60;
        }
    }
    return startMin <= hourMin && hourMin <= endMin;
}
export const formatDateToYMD = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
};
export interface ReviewProps {
    idavis:number,
    iduser:number,
    title: string,
    text: string,    
    note:number,
    note_detail?:[number,number,number],
    verif:boolean,
    visible:boolean,
    firstname: string, 
    photo: string,   
    nameR?: string,
    photoR?:string,
    user_grade: number,
    post_date:Date,
    response?:string, 
    post_date_response?:Date,
    idrestaurant?:number,
}

export interface ReviewPageProfilProps {
    idavis:number,
    title: string,
    text: string,  
    user_grade: number,  
    note:number,
    response?:string,
    post_date_response?:Date,
    post_date:Date,
    note_detail?:[number,number,number],
    idrestaurant:number,
    verif:boolean,
    restaurateur_img: string,  
    restaurant_name:string, 
    restaurant_devanture:string,
    restaurant_address:[string,string],
    restaurant_idurl:string,
}
export interface Point {
    type: string; 
    coordinates: [number, number]; 
}
export interface Restaurant {
    idrestaurant: number; 
    id_url:string,
    name: string;     
    devanture: string; 
    listimg?: string[];  
    note: number;     
    filters?: string[];  
    location: Point;
    type:string[];
    type_display:string,
    schedule: typeSchedule;
    special_date?: typeSpecialDate;
    date_published?:Date;
    nbr_review:number,
    address:[string,string],
    phone:string,
    price:[number,number]
    biography?:string;
    price_range:[number,number],
    cuisines:string[],
    visiblecity:string,
    score:number,
    date_update:Date,
    is_resa_phone:boolean,
    address_hint?:string,
    def_cuisine:string,
    neighborhood:string,
}
export interface Location {
  lat: number; 
  lng: number; 
  name: string;
  idrestaurant:number;
  is_resa_phone:boolean,
  nbr_review:number,
  filters?:string[],
  devanture:string;
  type:string[];
  type_display:string,
  note:number;
  id_url:string;
  address:[string,string];
  phone:string;
  listImg?:string[];
  biography?:string;
  schedule: typeSchedule;
  special_date?: typeSpecialDate;
  price_range:[number,number],
  cuisines:string[],
  date_update:Date,
  address_hint?:string,
  def_cuisine?:string,
}
export interface RestoFavProps {
    id_url:string,
    idrestaurant:number,
    address:[string,string];
    devanture:string,
    name:string,
    note:number,
    nbr_review:number,
}

export interface SubscribeProps {
    id:number,
    name:string,
    firstname:string,
    photo:string,
    nbr_review:number,
}

export interface Coordonates {
    latitude: string,
    longitude: string,
}
export const ListGrades: string[] = ['Novice','Apprenti Culinaire','Explorateur Culinaire','Maitre Culinaire','Elite Culinaire']


export async function fetchWithRefreshUser(url: string, options: RequestInit) {
    let response = await fetch(url, options);

    if (response.status === 401) { 
        const refreshResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenUser`, {
            method: 'POST',
            credentials: 'include'
        });
        if (refreshResponse.ok) {
            const data = await refreshResponse.json();
            localStorage.setItem('token', data.accessToken); 
            await new Promise(resolve => setTimeout(resolve, 100));
            response = await fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${data.accessToken}`, 
                },
            });
        } else {
            console.error('Erreur lors du rafraîchissement du token');
            return;
        }
    }

    return response;
}
function isImpersonationRestau() {
  return sessionStorage.getItem("impersonation") === "1";
}
export async function fetchWithRefreshRestau(url: string, options: RequestInit) {
    const impersonation = isImpersonationRestau();
    const headers = new Headers(options.headers || {});
    options.headers = headers;
    if (impersonation) {
      const token = sessionStorage.getItem("restau_access");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      } else {
        console.warn("Impersonation active mais restau_access absent en sessionStorage");
      }
    } else {
      if (!headers.has("Authorization")) {
        const token = localStorage.getItem("token");
        if (token) headers.set("Authorization", `Bearer ${token}`);
      }
    }

    let response = await fetch(url, options);
    if (response.status === 401 || response.status === 403) { 
        const refreshHeaders = new Headers();
        if (impersonation) {
            const refreshToken = sessionStorage.getItem("restau_refresh");
            if (refreshToken) {
                refreshHeaders.set("Authorization", `Bearer ${refreshToken}`);
            } else {
                console.warn("Impersonation active mais restau_refresh absent en sessionStorage");
            }
        }
        const refreshResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenRestau`, {
            method: 'POST',
            credentials: 'include',
            ...(impersonation && {headers: refreshHeaders})

        });
        if (refreshResponse.ok) {
            const data = await refreshResponse.json();
            if (impersonation) {
                sessionStorage.setItem("restau_access", data.accessToken);
            } else {
                localStorage.setItem('token', data.accessToken);
            }
             
            await new Promise(resolve => setTimeout(resolve, 100));
            if (!options.headers) {
                options.headers = new Headers();
            }
            if (options.headers instanceof Headers) {
                options.headers.set('Authorization', `Bearer ${data.accessToken}`);
            } else {
                const headers = new Headers(options.headers);
                headers.set('Authorization', `Bearer ${data.accessToken}`);
                options.headers = headers; 
            }
            response = await fetch(url, options);
        } else {
            console.error('Erreur lors du rafraîchissement du token');
            return;
        }
    }
    return response;
}

export const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, '');
        return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ');
};

export const  createImage = (url: string) =>
    new Promise<HTMLImageElement>((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.src = url;
});

export const getCroppedImg = async (imageSrc: string, crop: any,isBanner=false) => {
    const image: any = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const { width: naturalWidth, height: naturalHeight } = image;
    const scaleX = naturalWidth / image.width;
    const scaleY = naturalHeight / image.height;

    const croppedWidth = crop.width * scaleX;
    const croppedHeight = crop.height * scaleY;

    const MAX_SIDE = isBanner ? 2560 : 1920;
    const scaleDown = Math.min(1, MAX_SIDE / Math.max(croppedWidth, croppedHeight));
    const outW = Math.max(1, Math.round(croppedWidth * scaleDown));
    const outH = Math.max(1, Math.round(croppedHeight * scaleDown));

    canvas.width = outW;
    canvas.height = outH;

    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      croppedWidth,
      croppedHeight,
      0,
      0,
      canvas.width,
      canvas.height
    );
    const originalSizeInKB = Math.ceil((imageSrc.length * (3 / 4)) / 1024);


    let quality = isBanner ? 0.93 : 0.8; 
    if (originalSizeInKB > 3000 && !isBanner) {
        quality = 0.4; 
    } else if (originalSizeInKB > 1000 && !isBanner) {
        quality = 0.6;
    } 
    return canvas.toDataURL(`image/webp`,quality);
  };
export const leaveInputEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "Enter") {
    e.currentTarget.blur(); 
  }
};
  
export interface FilterItem {
    value: string;
    liste?: string[] ;
}

export type typeDailyMenu = {image:string,dates:Date[],name:string,display_order:number,visible:boolean}
export const TypeMeal = ["Brunch", "Déjeuner", "Dîner","Buffet"]
export const PerfectFor = ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']
export const allShowFilter = ['Notes','Prix par personne']
export const principalCuisine = ['Française','Italienne','Espagnole','Japonaise','Chinoise','Coréenne','Portugaise']

export const TIME_FILTERS = new Set(["Ouvert ce midi","Ouvert ce soir","Ouvert demain midi","Ouvert demain soir","Ouvert maintenant"]);
export const listFilters: FilterItem[] = [
    {value: "Type de restaurant", liste: TypeResto},
    {value: 'Origine de la cuisine', liste: []},
    {value:'Moyen de paiement', liste:['Carte bancaire', 'American Express','Carte ticket restaurant' ,'Ticket restaurant', 'Chèques','Chèque-vacances','Chèques vacances connect','Espèces']},
    {value:'Prix par personne'},
    {value:'Idéal pour', liste: ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']},
    {value:'Ambiance et expérience', liste:['Vue exceptionnelle', 'Lieu historique','Spécialités locales','Calme','Nature','Bord de l’eau','Rooftop','Cadre romantique','Cadre atypique']},
    {value:'Régime alimentaire', liste:['Végétarien','Végan','Sans gluten','Sans lactose','Halal','Kasher ']},
    {value:'Options pratiques', liste:['Ingrédients de saison','Événement','Privatisable','Bons cadeaux','Brunch','Service en continu','Animaux autorisés','Terrasse extérieure','Terrasse couverte','Terrasse ombragée','Espace business','Salle climatisée','Traiteur','Wifi disponible']},
    {value:'Parking', liste:['Stationnement facile','Parking à proximité','Parking gratuit','Parking couvert','Parking privé','Borne de recharge','Parking PMR']},
    {value:'Notes'},
    {value:'Accessibilités', liste:['Accès PMR','Toilettes PMR','Equipe formée LSF','Adapté aux poussettes','Table à langer']},
]
export const listFiltersResto: FilterItem[] = [
  {value:'Moyen de paiement', liste:['Carte bancaire', 'American Express', 'Carte ticket restaurant' , 'Ticket restaurant', 'Chèques','Chèque-vacances','Chèques vacances connect','Espèces']},
  {value:'Idéal pour', liste: ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']},
  {value:'Ambiance et expérience', liste:['Vue exceptionnelle', 'Lieu historique','Spécialités locales','Calme','Nature','Bord de l’eau','Rooftop','Cadre romantique','Cadre atypique']},
  {value:'Régime alimentaire', liste:['Végétarien','Végan','Sans gluten','Sans lactose','Halal','Kasher ']},
  {value:'Options pratiques', liste:['Ingrédients de saison','Événement','Privatisable','Bons cadeaux','Brunch','Service en continu','Animaux autorisés','Terrasse extérieure','Terrasse couverte','Terrasse ombragée','Espace business','Salle climatisée','Traiteur','Wifi disponible']},
  {value:'Parking', liste:['Stationnement facile','Parking à proximité','Parking gratuit','Parking couvert','Parking privé','Borne de recharge','Parking PMR']},
  {value:'Accessibilités', liste:['Accès PMR','Toilettes PMR','Equipe formée LSF','Adapté aux poussettes','Table à langer']},
]
export const getVisibleFilters = (filters: FilterValue[]): FilterValue[] => {
    return filters.filter(filter => !(typeof filter === "string" &&TIME_FILTERS.has(filter)));
};
export type InformationProfilRestau =  [string,string,string,boolean,string,string]
export interface InformationResto {
    listImg: string[];
    biography: string;
    price_range: [number,number];
    visibleCity: string;
    addressHint: string;
    defCuisine: string;
    neighborhood:string;
}

export const getPurifyMail = (email:string) => {
    let cleanMail = DOMPurify.sanitize(email);
    let [localPart, domainPart] = cleanMail.split('@');
    if (localPart && domainPart) {
        cleanMail = `${localPart.toLowerCase()}@${domainPart}`;
    }
    cleanMail = cleanMail.toLocaleLowerCase();
    cleanMail = cleanMail.replace(/\s/g, '');
    return cleanMail;
}

export type CommandProps = [string,number,string,number,Date[],number,number]

export interface ValuesInvoices {
    post_date: Date,
    ref:string,
    company_name: string,
    address:string,
    payment_methode:string,
    command:CommandProps[],
    nbrbilling:string,
    city:string,
    zipcode:string,
    before_payment:boolean,
    refabo?:string,
    customer_ref?:string,
    id?:number,
    creditNotes?: CreditNoteProps[];
    link_document?:string,
}
export interface CreditNoteProps {
  id?: number;
  billing_id: number;

  post_date: Date;
  ref: string;

  nbrcreditnote: string;

  original_nbrbilling: string;
  original_post_date: Date;

  subscription_id?: number;

  name_client?: string;
  company_name: string;
  address: string;
  city: string;
  zipcode: string;
  payment_methode: string;
  refabo?: string;
  customer_ref?: string;

  command_base: CommandProps[];
  command_credit_note: CommandProps[];
  motif?:string,
  link_document?:string,
}


export const slugify = (str:string) => {
  return str
    .toLowerCase()
    .normalize('NFD')               
    .replace(/[\u0300-\u036f]/g, '') 
    .replace(/'/g, '-')           
    .replace(/\s+/g, '-')    
    .replace(/[^a-z0-9-]/g, '')   
    .replace(/--+/g, '-')         
    .replace(/^-+|-+$/g, '');     
}
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}
export const clickPhone = async (id_url:string,restoPhoneClicks:string[],setRestoPhoneClicks:Dispatch<SetStateAction<string[]>>,idrestaurant?:number) => {
    if (restoPhoneClicks.includes(id_url)) return;
    setRestoPhoneClicks([...restoPhoneClicks,id_url]);
    const IS_PROD_FR = window.location.host.endsWith('quelresto.fr');

    let hasAnalyticsConsent = false;
    try {
      const cookieConsent = document.cookie.split('; ').find(r => r.startsWith('QUELRESTO_COOKIE='));
      if (cookieConsent) {
        const cookieValue = decodeURIComponent(cookieConsent.split('=')[1]);
        const parsed = JSON.parse(cookieValue);
        hasAnalyticsConsent = !!parsed?.['perform-analytics'];
      }
    } catch { }
    if (
      IS_PROD_FR &&
      hasAnalyticsConsent &&
      typeof window.gtag === 'function' &&
      process.env.REACT_APP_TAG_ANALYSE_ADS &&
      process.env.REACT_APP_ADS_LABEL_PHONE  
    ) {
      window.gtag('event', 'conversion', {
        send_to: `${process.env.REACT_APP_TAG_ANALYSE_ADS}/${process.env.REACT_APP_ADS_LABEL_PHONE}`
      });
    }
    try {
        await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/updatePhoneClick`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ idrestaurant: idrestaurant }),
        });
        
    } catch (error) {
        console.error("Erreur lors de la connexion :", error);
    }
  
}
export const AsCookieAnalyticsConsent = () => {
  let hasAnalyticsConsent = false;
  try {
    const cookieConsent = document.cookie.split('; ').find(r => r.startsWith('QUELRESTO_COOKIE='));
    if (cookieConsent) {
      const cookieValue = decodeURIComponent(cookieConsent.split('=')[1]);
      const parsed = JSON.parse(cookieValue);
      hasAnalyticsConsent = !!parsed?.['perform-analytics'];
    }
  } catch { }
  return hasAnalyticsConsent
}
export const getPageContextAnalytics = (): "home" | "map" => {
  return window.location.pathname.includes("/map") ? "map" : "home";
};
type GaParams = Record<string, string | number | boolean>;
export const trackGaEventOncePerSession = (
  sessionKey: string,
  eventName: string,
  params?: GaParams
) => {
  if (sessionStorage.getItem(sessionKey) === "1") return;
  if (!(AsCookieAnalyticsConsent() && typeof window.gtag === "function")) return;

  window.gtag!("event", eventName, params || {});
  sessionStorage.setItem(sessionKey, "1"); 
};
export const trackRestoTabViewOncePerSession = ({
  restaurantId,
  tabName,
}: {
  restaurantId: number;
  tabName:  "restaurant" | "menu" | "reservation";
}) => {
  if (!Number.isFinite(restaurantId) || restaurantId <= 0) return;
  if (!(AsCookieAnalyticsConsent() && typeof window.gtag === "function")) return;
  const sessionKey = `qr_resto_tab_view_${restaurantId}_${tabName}`;
  if (sessionStorage.getItem(sessionKey) === "1") return;
  window.gtag("event", "qr_resto_tab_view", {
    restaurant_id: restaurantId,
    tab_name: tabName,
  });
  sessionStorage.setItem(sessionKey, "1");
};
type FilterAnalyticsBucket = "first" | "second" | "thirdplus";
type FilterAnalyticsSessionState = {
  first: Record<string, Record<string, true>>;
  second: Record<string, true>;
  thirdplus: Record<string, true>;
};
const FILTER_ANALYTICS_SESSION_KEY = "qr_analytics_session_state";
const getEmptyFilterAnalyticsState = (): FilterAnalyticsSessionState => ({ first: {}, second: {}, thirdplus: {}});
const readFilterAnalyticsSessionState = (): FilterAnalyticsSessionState => {
  try {
    const raw = sessionStorage.getItem(FILTER_ANALYTICS_SESSION_KEY);
    if (!raw) return getEmptyFilterAnalyticsState();
    const parsed = JSON.parse(raw);
    return {
      first: parsed?.first && typeof parsed.first === "object" ? parsed.first : {},
      second: parsed?.second && typeof parsed.second === "object" ? parsed.second : {},
      thirdplus: parsed?.thirdplus && typeof parsed.thirdplus === "object" ? parsed.thirdplus : {}
    };
  } catch {
    return getEmptyFilterAnalyticsState();
  }
};
const writeFilterAnalyticsSessionState = (state: FilterAnalyticsSessionState) => {sessionStorage.setItem(FILTER_ANALYTICS_SESSION_KEY, JSON.stringify(state));};
const normalizeAnalyticsValue = (value: string) => String(value || "").trim().toLowerCase();
export const trackGaFilterEventOncePerSession = ({bucket,eventName,filterName,pageContext,params}: {bucket: FilterAnalyticsBucket;eventName: string;filterName: string;pageContext?: string;params?: GaParams;}) => {
  const normalizedFilterName = normalizeAnalyticsValue(filterName);
  const normalizedPageContext = normalizeAnalyticsValue(pageContext || "");
  if (!normalizedFilterName) return;
  if (!(AsCookieAnalyticsConsent() && typeof window.gtag === "function")) return;

  const state = readFilterAnalyticsSessionState();
  if (bucket === "first") {
    if (!normalizedPageContext) return;
    if (!state.first[normalizedPageContext]) state.first[normalizedPageContext] = {};
    if (state.first[normalizedPageContext][normalizedFilterName]) return;
    window.gtag!("event", eventName, params || {});
    state.first[normalizedPageContext][normalizedFilterName] = true;
    writeFilterAnalyticsSessionState(state);
    return;
  }
  if (state[bucket][normalizedFilterName]) return;
  window.gtag!("event", eventName, params || {});
  state[bucket][normalizedFilterName] = true;
  writeFilterAnalyticsSessionState(state);
};
const atMidnight = (d: Date) => { const x = new Date(d); x.setHours(0,0,0,0); return x; };
const getMonday = (d: Date) => {
  const x = atMidnight(d);
  const day = x.getDay() || 7;
  if (day !== 1) x.setDate(x.getDate() - (day - 1));
  return x;
};
const getSunday = (d: Date) => {
  const mon = getMonday(d);
  const sun = new Date(mon);
  sun.setDate(mon.getDate() + 6);
  return sun;
};

export interface statsProps {
  averageSessionDuration:number,
  engagementRate: number,
  screenPageViews: number,
  totalUsers:number
}
export interface statsDatesProps {
  end:Date,
  start:Date,
  data:statsProps,
}
const NULL_WEEK:statsDatesProps = {
  start: new Date(),
  end:new Date(),
  data:{
  averageSessionDuration: -1,
  engagementRate: -1,
  screenPageViews: -1,
  totalUsers: -1,
  }
};
export function weekSlotsInCurrentMonth(today = new Date()): number {
  const y = today.getFullYear();
  const m = today.getMonth();

  const firstOfMonth = new Date(y, m, 1);
  const lastOfMonth  = new Date(y, m + 1, 0);

  const firstMonday  = getMonday(firstOfMonth);  
  const lastSunday   = getSunday(lastOfMonth);   

  const DAY_MS = 24 * 60 * 60 * 1000;
  const diffDaysInclusive =
    (atMidnight(lastSunday).getTime() - atMidnight(firstMonday).getTime()) / DAY_MS
    + 1;

  return Math.round(diffDaysInclusive / 7);
}
export function padWeeks(weeks: statsDatesProps[], target: number): statsDatesProps[] {
  const out = weeks.slice(0, target);
  while (out.length < target) out.push({ ...NULL_WEEK });
  return out;
}



export interface statsPointProps {
  percentTop:number,
  percentLeft:number,
  value:string,
  currentResa?:number,
  currentIncome?:number,
  currentCA?:number
}

export type trackingInfoProps = [number,number];

export type ClickStats = {
  year: string;
  month: string;
  week:number;
  clicks: string;
};
export type DetailStatsPhoneRow = {
  clicked_at: string;
  year: number;
  month: number;
  day_of_week: number;
  hour: number;
};

export const niceCeil = (n:number) => {
      if (!Number.isFinite(n) || n <= 0) return 0;
      const log = Math.floor(Math.log10(n));
      const base = Math.pow(10, log);
      return Math.ceil(n / base) * base;
    };
export const getNiceYAxisLabels = (maxValue: number, steps: number = 4): number[] => {
  const adjustedMax = maxValue * 1.15;
  const roughStep = adjustedMax / steps;
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));

  let baseSteps = [1, 2, 5, 10];
  if (magnitude >= 100) baseSteps = [1, 2, 5, 10, 20, 50];

  const niceStep = baseSteps.find(step => step * magnitude >= roughStep)! * magnitude;
  if(adjustedMax === 0 ) return baseSteps;
  const labels: number[] = [];
  for (let i = 0; i <= steps; i++) {
    const val = i * niceStep;
    if (val >= adjustedMax || i === steps) {
      labels.push(val);
      break;
    }
    labels.push(val);
  }

  return labels;
}

export const typemealMap: { [key: string]: number } = {
  "Brunch":0,
  "Déjeuner":1,
  "Dîner":2,
  "Buffet":3,
};
export const perfectforMap: { [key: string]: number } = {
  "En famille":0,
  "En famille avec enfants":1,
  "En couple":2,
  "Entre amis":3,
  "Avec soi-même":4,
  "Repas d’affaires":5,
  "Grandes occasions":6,
};

export interface UserModerationProps {
    photo:string,
    name:string,
    firstname:string,
    creation_date:Date,
    blamereview:number,
    id:number,
    biography:string
}
export interface RestaurateurModerationProps {
    idrestaurant:number,
    name:string,
    address:[string,string],
    published:boolean,
    monthoffert:number,
    id_url:string,
    is_sub:boolean,
}
export const listReport = ["Il contient un langage grossier ou vulgaire" , "Il contient du contenu discriminatoire ou une incitation à la haine", "L'avis est mensonger ou faux", "Il a un contenu explicitement sexuel","Il est destiné à un autre établissement", "Il a été écrit par une personne affiliée à l'établissement","Autre raison"]

export const publicHolidays = [
  '01-01-2026', '06-04-2026', '01-05-2026', '08-05-2026',
  '14-05-2026', '25-05-2026', '14-07-2026', '15-08-2026',
];

export type Birth = { day: string; month: string; year: string };
export type ProfileBaseForm = { phone: string; postalCode: string; birth: Birth,emptyPhone:boolean,emptyBirth:boolean,emptyPostalCode:boolean,logGoogle:boolean };

export function useMediaQuery(query: string) {
  const [match, setMatch] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );
  useEffect(() => {
    const m = window.matchMedia(query);
    const onChange = () => setMatch(m.matches);
    m.addEventListener?.("change", onChange);
    return () => m.removeEventListener?.("change", onChange);
  }, [query]);
  return match;
}

export function cityWithPreposition(city:string) {
  const c = (city || '').trim();
  if (/^Les\s/i.test(c)) {
    return `aux ${c.replace(/^Les\s/i, '')}`; 
  }
  if (/^Le\s/i.test(c)) {
    return `au ${c.replace(/^Le\s/i, '')}`;   
  }
  if (/^La\s/i.test(c)) {
    return `à ${c}`;                        
  }
  if (/^L['’]/i.test(c)) {
    return `à ${c}`;
  }
  return `à ${c}`;  
}
export function cityWithOtherPreposition(cityWithPrep: string) {
  const c = (cityWithPrep || '').trim();

  if (/^aux\s/i.test(c)) {
    return `des ${c.replace(/^aux\s/i, '')}`;
  }
  if (/^au\s/i.test(c)) {
    return `du ${c.replace(/^au\s/i, '')}`;
  }
  if (/^à\s+l['’]/i.test(c)) {
    return `de l${c.replace(/^à\s+l/i, '')}`;
  }
  if (/^à\s+la\s/i.test(c)) {
    return `de la ${c.replace(/^à\s+la\s/i, '')}`;
  }
  if (/^à\s/i.test(c)) {
    const name = c.replace(/^à\s/i, '');
    return /^[aeiouâêîôûéèëïöüàä]/i.test(name)
      ? `d'${name}`
      : `de ${name}`;
  }
  return c;
}

export const faqBase = [[`Comment trouver un restaurant à proximité ou autour de moi`,'Pour trouver un restaurant à proximité, cliquez sur « Lancer ma recherche » sur mobile. Sur ordinateur, la recherche est directement accessible en haut de la page. Dans « Où voulez-vous manger ? », sélectionnez ensuite « À proximité » pour trouver les restaurants autour de vous en fonction de votre position. Vous pouvez aussi entrer le nom de votre ville dans la barre de recherche pour découvrir les restaurants à proximité, ou explorer la map QuelResto pour visualiser facilement les restaurants autour de vous.'],
  ['Quels restaurants sont ouverts aujourd’hui, ce soir ou le dimanche','Pour savoir quels restaurants sont ouverts maintenant, ce midi, ce soir ou le dimanche, cliquez sur « Lancer ma recherche » sur mobile, puis accédez aux champs « Date » et « Heure » (directement accessibles en haut de la page sur ordinateur). Sélectionnez ensuite la date et l’heure souhaitées pour afficher uniquement les restaurants ouverts le jour et à l’heure de votre choix.'],
  ['Quels sont les meilleurs restaurants selon les avis et les notes','Les meilleurs restaurants sur QuelResto sont mis en avant grâce à un algorithme qui prend en compte le nombre d’avis et la note moyenne de chaque établissement. Les restaurants les mieux notés apparaissent en haut des résultats, afin que vous puissiez repérer rapidement les adresses les plus appréciées selon les avis clients.'],
  ['Comment trouver un restaurant pas cher, romantique, avec terrasse, concrètement un restaurant adapté à mes envies ou à mes besoins','Pour trouver un restaurant pas cher, romantique, avec terrasse ou répondant à une envie ou un besoin spécifique, utilisez les filtres de QuelResto. Vous pouvez par exemple sélectionner le budget, l’ambiance, un régime alimentaire (végétarien, végan, halal, sans gluten) mais aussi des critères comme l’accessibilité PMR ou le parking. L’ensemble des filtres disponibles vous permet ainsi de trouver facilement le restaurant le plus adapté à vos envies et à vos besoins.'],
  ['Où voir la carte, les photos et les avis d’un restaurant','Chaque restaurant dispose d’une page complète avec sa carte, ses photos, ses horaires et les avis clients. Un aperçu avec les photos, le type de restaurant, le prix moyen, la note et la localisation est aussi visibles dès la page d’accueil de QuelResto.'],
  ['Les avis des restaurants sur QuelResto sont-ils fiables et vérifiés','Tous les avis clients publiés sur QuelResto passent par une modération : nous retirons les contenus frauduleux ou inappropriés pour garantir des avis authentiques et utiles. À l’avenir, grâce à la réservation en ligne, il sera possible de laisser des avis 100 % vérifiés. Ces avis fiables vous permettent de comparer facilement les restaurants et de faire votre choix en toute confiance.'],
  ['Peut-on réserver un restaurant en ligne sur QuelResto','Sur chaque page restaurant, vous retrouvez une section réservation avec le numéro de téléphone du restaurant. Si l’établissement propose une réservation en ligne via son propre outil, un lien pour vous y rediriger est affiché. Plus tard, QuelResto intégrera sa propre réservation en ligne pour réserver rapidement et avoir des avis vérifiés. Vous pourrez ainsi réserver un restaurant en quelques clics, simplement et en toute confiance.'],
  ['Les informations des restaurants (horaires, prix, carte, photos, avis) sont-elles à jour sur QuelResto','Oui. Le prix moyen est calculé automatiquement à partir des données fournies et des avis récents. Les horaires, la carte et les photos sont mis à jour directement par les restaurateurs, avec la date de mise à jour affichée sur la carte et les horaires. Les avis clients indiquent toujours la date de publication, ce qui garantit des informations fiables et actualisées. Ainsi, vous avez l’assurance de consulter des restaurants avec des données à jour pour faire votre choix en toute confiance.']]
     
export const  faqProx = [['Comment trouver un restaurant à proximité ou autour de moi','Pour trouver un restaurant à proximité, cliquez sur « Lancer ma recherche » sur mobile. Sur ordinateur, la recherche est directement accessible en haut de la page. Dans « Où voulez-vous manger ? », sélectionnez ensuite « À proximité » pour trouver les restaurants autour de vous en fonction de votre position. Vous pouvez aussi entrer le nom de votre ville dans la barre de recherche pour découvrir les restaurants à proximité, ou explorer la map QuelResto pour visualiser facilement les restaurants autour de vous.'],
  ['Quels restaurants à proximité sont ouverts aujourd’hui ou ce soir','Pour savoir quels restaurants à proximité sont ouverts maintenant, ce midi, ce soir ou le dimanche, cliquez sur « Modifier ma recherche » sur mobile, puis accédez aux champs « Date » et « Heure » (directement accessibles en haut de la page sur ordinateur). Sélectionnez ensuite la date et l’heure souhaitées pour afficher uniquement les restaurants ouverts le jour et à l’heure de votre choix.'],
  ['Comment trouver un restaurant pas cher autour de moi','Pour savoir quels restaurants à proximité ne sont pas chers, cliquez sur « Filtres », directement accessible en haut de la page. Vous pouvez ensuite choisir un budget maximum pour afficher uniquement les restaurants pas chers et à proximité de vous. '],
  ['Peut-on réserver un restaurant à proximité en ligne','Sur chaque page restaurant, une section réservation affiche le numéro de téléphone. Si l’établissement propose une réservation en ligne via son propre outil, un bouton de redirection est disponible. Bientôt, QuelResto intégrera sa propre réservation en ligne pour réserver directement un restaurant à proximité en quelques clics.']]


export function LineSeparationSVG({
    type = 0,
    thickness = 1,
    color = "#000000",
    wave = 0,        
    width = 80,    
    gradient = false,
    isMenu = true,
  }: {
    type:number;
    thickness: number;
    color: string;
    wave: number;
    width: number;
    gradient: boolean;
    isMenu?:boolean,
  }) {
    const W = 1000;
    const H = 1000;
  
    let w = Math.min(100, Math.max(10, width));
    let periods = (Math.round(5 + (w - 10) * (15 / 90)))*(isMenu ? 1 : 2);
    const A = (Math.max(0, Math.min(100, wave)) / 100) * (0.4 * H);
    const midY = H / 2;
    const step = W / periods;
  
    let d = `M 0 ${midY}`;
    for (let i = 0; i < periods; i++) {
      const x1 = i * step + step / 2;
      const x2 = (i + 1) * step;
      const up = i % 2 === 0 ? -A : A;
      d += ` Q ${x1} ${midY + up}, ${x2} ${midY}`;
    }
  
    const dashArray =
      type === 1
        ? `${thickness * 3} ${thickness * 2}` 
        : type === 2
        ? `${thickness} ${thickness * 2}`   
        : undefined;
  
    const linecap = type === 2 ? "round" : "butt";
  
  
    const gid = `grad-${Math.random().toString(36).slice(2)}`
  
    return (
      <svg
        width={`${width}%`}
        height={20}
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        {gradient && (
          <defs>
            <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%"   stopColor={color} stopOpacity="0" />
              <stop offset="15%"  stopColor={color} stopOpacity=".25" />
              <stop offset="50%"  stopColor={color} stopOpacity="1" />
              <stop offset="85%"  stopColor={color} stopOpacity=".25" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
        )}
  
        <path d={d} fill="none" stroke="transparent" strokeWidth={Math.max(10, thickness + 8)} />
  
        <path
          d={d}
          fill="none"
          stroke={gradient ? `url(#${gid})` : color}
          strokeWidth={thickness}          
          strokeDasharray={dashArray}
          strokeLinecap={linecap}
          vectorEffect="non-scaling-stroke" 
        />
      </svg>
    );
  }

const formatDateDailyMenu = (date:Date,isLower=false) => {
    const formatted = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric" }).format(date);
    return isLower ? formatted.charAt(0).toLocaleLowerCase() + formatted.slice(1) : formatted.charAt(0).toUpperCase() + formatted.slice(1); 
  };
export const getSentencesDailyMenu = (dateChoose:Date | null,scndDateChoose:Date | null) => {
    let isChooseToday = dateChoose ? (dateChoose.toDateString() === new Date().toDateString()) : false
    return dateChoose ? 
        (scndDateChoose ? (isChooseToday ? `Votre menu sera publié aujourd’hui jusqu’au ${formatDateDailyMenu(scndDateChoose,true)} (inclus).` : `Votre menu sera publié du ${formatDateDailyMenu(dateChoose,true)} jusqu’au ${formatDateDailyMenu(scndDateChoose,true)} (inclus).`)
            : (isChooseToday ? `Votre menu sera publié aujourd’hui jusqu’à 23h59.` : `Votre menu sera publié le ${formatDateDailyMenu(dateChoose,true)}.`)) 
        : 'Pour publier votre menu du jour, sélectionnez une date.'
}

export const listColor = ['#000000','#606060','#787878','#999799','#c0c0c0','#ffffff','#00167a','#0081cc','#2b51ff','#7a005f','#ac42ab','#cc008d','#007a3c','#48ac42','#00cc52','#d90404','#f07606',  '#e9c012'];
export const listColorBack = ['#000000','#787878','#a8a7a8','#c9c9c9','#ebebeb','#ffffff','#6d72b8','#70a1ce','#7ba4ff','#ae6db8','#ce70b4','#ffabdd','#6db872','#83ce70','#c6ffab','#ff6f6f','#f3a45c',  '#f9ffb2'];
export  const listGradient = [
      "linear-gradient(90deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0.50) 100%)",
      "linear-gradient(90deg, rgba(96, 96, 96, 0.50) 0%, rgba(96, 96, 96, 1) 50%, rgba(96, 96, 96, 0.50) 100%)",

      "linear-gradient(90deg, rgba(120, 120, 120, 0.50) 0%, rgba(120, 120, 120, 1) 50%, rgba(120, 120, 120, 0.50) 100%)",
      "linear-gradient(90deg, rgba(153, 151, 153, 0.50) 0%, rgba(153, 151, 153, 1) 50%, rgba(153, 151, 153, 0.50) 100%)",
      "linear-gradient(90deg, rgba(192, 192, 192, 0.50) 0%, rgba(192, 192, 192, 1) 50%, rgba(192, 192, 192, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.50) 100%)",

      "linear-gradient(90deg, rgba(0, 22, 122, 0.50) 0%, rgba(0, 22, 122, 1) 50%, rgba(0, 22, 122, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 129, 204, 0.50) 0%, rgba(0, 129, 204, 1) 50%, rgba(0, 129, 204, 0.50) 100%)",
      "linear-gradient(90deg, rgba(43, 81, 255, 0.50) 0%, rgba(43, 81, 255, 1) 50%, rgba(43, 81, 255, 0.50) 100%)",
      "linear-gradient(90deg, rgba(122, 0, 95, 0.50) 0%, rgba(122, 0, 95, 1) 50%, rgba(122, 0, 95, 0.50) 100%)",
      "linear-gradient(90deg, rgba(204, 0, 141, 0.50) 0%, rgba(204, 0, 141, 1) 50%, rgba(204, 0, 141, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 82, 186, 0.50) 0%, rgba(255, 82, 186, 1) 50%, rgba(255, 82, 186, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 122, 60, 0.50) 0%, rgba(0, 122, 60, 1) 50%, rgba(0, 122, 60, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 204, 82, 0.50) 0%, rgba(0, 204, 82, 1) 50%, rgba(0, 204, 82, 0.50) 100%)",
      "linear-gradient(90deg, rgba(46, 255, 35, 0.50) 0%, rgba(46, 255, 35, 1) 50%, rgba(46, 255, 35, 0.50) 100%)",
      "linear-gradient(90deg, rgba(217, 4, 4, 0.50) 0%, rgba(217, 4, 4, 1) 50%, rgba(217, 4, 4, 0.50) 100%)",
      "linear-gradient(90deg, rgba(240, 118, 6, 0.50) 0%, rgba(240, 118, 6, 1) 50%, rgba(240, 118, 6, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 216, 16, 0.50) 0%, rgba(255, 216, 16, 1) 50%, rgba(255, 216, 16, 0.50) 100%)",
  ];


export const isArrayCodeFull = (code:string[]) => {
  if(code.length === 6) {
    for(const elem of code) {
      if(!elem || elem === '') return false
    }
    return true
  } else return false
}
export type DeviceState = {
  isPhone: boolean;
  isTapDevice: boolean;
  canHover: boolean;
  windowWidth: number;
};
type BillingType = 'invoice' | 'creditNote';
export async function openSignedBillingLink({type,id,isAdmin,token}: {
  type: BillingType;
  id: number | string;
  isAdmin: boolean;
  token?: string | null;
}) {
  const url = isAdmin ? `${process.env.REACT_APP_DIRECTION_REQUEST}/api/admin/getLinkInvoice` : `${process.env.REACT_APP_DIRECTION_REQUEST}/api/getLinkInvoice`;

  const response = await (isAdmin ? fetch : fetchWithRefreshRestau)(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && !isAdmin ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: 'include',
    body: JSON.stringify({ type, id }),
  });

  if (!response) return false;

  const result = await response.json();

  if (result.success && result.url) {
    window.open(result.url, '_blank', 'noopener,noreferrer');
    return true;
  }

  return false;
}
export const showPdf = async (data:ValuesInvoices) => {
  if (data.id === undefined || data.id === null) {
    alert('Une erreur est survenue');
    return;
  }
  const token = localStorage.getItem('token');
  if(data.link_document) {
      openSignedBillingLink({type:'invoice',id:data.id, isAdmin:false, token})
      return;
  }
  try {
        const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getBillingDocument`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
            },
            credentials:'include',
            body: JSON.stringify({
                type: 'invoice',
                id: data.id,
            }),
        });
        if(response) {
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
                const result = await response.json();

                if (result.success && result.link_document) {
                    data.link_document = result.link_document;
                    openSignedBillingLink({type:'invoice',id:data.id, isAdmin:false, token})
                    return;
                }

                alert('Une erreur est survenue');
                return;
            }

            const blob = await response.blob();
            const pdfUrl = URL.createObjectURL(blob);
            window.open(pdfUrl, '_blank', 'noopener,noreferrer');

            setTimeout(() => {
                URL.revokeObjectURL(pdfUrl);
            }, 10000);
        } else  alert('Une erreur est survenue');

    } catch (error) {
        console.error('Erreur affichage facture :', error);
        alert('Une erreur est survenue');
    }

}

export const showCreditNote = async (data:CreditNoteProps) => {
  if (data.id === undefined || data.id === null) {
    alert('Une erreur est survenue');
    return;
  }
  const token = localStorage.getItem('token');
  if(data.link_document) {
      openSignedBillingLink({type:'creditNote',id:data.id, isAdmin:false, token})
      return;
  }
  try {
        const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getBillingDocument`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
            },
            credentials:'include',
            body: JSON.stringify({
                type: 'creditNote',
                id: data.id,
            }),
        });
        if(response) {
          const contentType = response.headers.get('content-type') || '';

          if (contentType.includes('application/json')) {
              const result = await response.json();

              if (result.success && result.link_document) {
                  data.link_document = result.link_document;
                  openSignedBillingLink({type:'creditNote',id:data.id, isAdmin:false, token})
                  return;
              }
              alert('Une erreur est survenue');
              return;
          }
          const blob = await response.blob();
          const pdfUrl = URL.createObjectURL(blob);
          window.open(pdfUrl, '_blank', 'noopener,noreferrer');

          setTimeout(() => {
              URL.revokeObjectURL(pdfUrl);
          }, 10000);
        }else alert('Une erreur est survenue');

    } catch (error) {
        console.error('Erreur affichage avoir :', error);
        alert('Une erreur est survenue');
    }

}

export interface BodyViewProps {
  listBase: Restaurant[];
  setLengthResto: Dispatch<SetStateAction<number>>;
  cityLoad?: string;
  cityLoadBrut?: string;
}

export type PageKind = 'city' | 'city_filter' | 'filter' | 'special';
export type FilterType = 'classic_filter' | 'type_resto' | 'cuisine' | 'regime';
export type HomepageZone =  "fixed_top" | "fixed" | "rotating";
export interface IndexablePage {
  id: number;
  city_name: string | null;
  city_slug: string | null;
  filter_name: string | null;
  filter_slug: string | null;
  filter_type: FilterType | null;
  page_kind: PageKind;
  special_kind: string | null;
  slug_path: string | null;
  label: string;
  seo_title: string | null;
  seo_description: string | null;
  suggestion_weight: number;
  homepage_zone: HomepageZone | null;
  homepage_weight: number;
  created_at: string;
  updated_at: string;
}

export const neighborhoodsByCity:Record<string, [string,string[][]][]> = {
  angers: [
    ["Centre Ville d’Angers",[["Ralliement"],["Château"],["Mail"],["Gare"]]],
    ["Angers Ouest",[["Doutre","Saint-Jacques-Nazareth"],["Belle-Beille","Lac de Maine"]]],
    ["Angers Sud",[["La Fayette-Eblé","Roseraie-Orgemont"],["Justices-Madeleine-Saint Léonard"]]],
    ["Angers Nord & Est",[["Saint Serge","Montplaisir"],["Deux Croix-Banchais"],["Les Hauts de Saint-Aubin"]]],
  ]
};

export interface HomeRestaurant {
  idrestaurant:number,
  devanture : string,
  note: number,
  name: string,
  id_url:string,
  type:string[],
  type_display?:string,
  visiblecity?:string,
  address:[string,string],
  nbr_review:number,
  price_range:[number,number],
  date_published?:Date,
  def_cuisine:string,
}
export type FilterValue = string | [number, number];
export const formatFilterLabel = (filter: FilterValue) => {
    if (typeof filter === "number") return `${filter} km`;
    if (Array.isArray(filter)) return `${filter[0]} - ${filter[1] === 100 ? `${filter[1]}€+` : `${filter[1]} €`}`;

    const parsed = parseRestaurantType(filter);
    if (parsed.kind === "dish" || parsed.kind === "country" || parsed.kind === "french-region" || parsed.kind === "cultural-region" || parsed.kind === "regime" || parsed.kind === "concept-unique") {
        return parsed.value;
    }

    return filter;
};

export interface GlobalOptionsElem {
  label:string;
  value:string;
  region?:string;
}
export const getCuisineDisplayLabel = (value: string): string => {
    const separatorIndex = value.indexOf(':');

    if (separatorIndex === -1) {
        return value;
    }

    return value.slice(separatorIndex + 1).trim();
};

export const parsePriceRange = (value: unknown): [number, number] => {
    if (Array.isArray(value)) {
        const min = Number(value[0]);
        const max = Number(value[1]);
        if (Number.isFinite(min) && Number.isFinite(max)) return [min, max];
    }
    if (typeof value === "string") {
        const match = value.match(/^[[(]\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*[\])]$/);
        if (match) return [Number(match[1]), Number(match[2])];
    }
    return [0,0];
};